import { render, staticRenderFns } from "./recordInfo.vue?vue&type=template&id=f27802e6&scoped=true"
import script from "./recordInfo.vue?vue&type=script&lang=js"
export * from "./recordInfo.vue?vue&type=script&lang=js"
import style0 from "./recordInfo.vue?vue&type=style&index=0&id=f27802e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27802e6",
  null
  
)

export default component.exports